import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { JobParameterService } from './common/job-parameter.service';

@Injectable({
  providedIn: 'root'
})
export class JobService extends JobParameterService {
  private datePipe: DatePipe = new DatePipe('zh-cn');

  constructor(
    protected httpClient: HttpClient,
    protected store: Store,
  ) {
    super(httpClient, store);
  }

  async testJobEvent() {
  }

  async getJobs(
    pageNum: number, pageSize: number, beginDate?: Date, endDate?: Date,
    typeId?: any, priority?: string, status?: string, callerId?: string,
    repairerId?: string, isProcessing?: boolean, search?: string, epNo?: string,
    timeSortOrder?: number,
    idSortOrder?: number, prioritySortOrder?: number, isDelay?: number,
    assetLevel?: string[], isEquipment?: string, source?: string, isAccidentShutdown?: string,
    isDuplicate?: string
  ): Promise<any> {
    let condition = '?pageNum=' + pageNum + '&pageSize=' + pageSize;
    if (assetLevel !== undefined && assetLevel !== null && assetLevel.length !== 0) {
      condition += '&assetLevel=' + assetLevel;
    }
    if (isEquipment != null) {
      condition += '&isEquipment=' + isEquipment;
    }
    if (source != null && source.length !== 0) {
      condition += '&source=' + source.toString();
    }
    if (beginDate != null) {
      condition += '&startTime=' + this.datePipe.transform(beginDate, 'yyyy-MM-dd 00:00:00');
    }
    if (endDate != null) {
      condition += '&endTime=' + this.datePipe.transform(endDate, 'yyyy-MM-dd 23:59:59');
    }
    if (typeId != null) {
      condition += '&businessTypeId=' + typeId.toString();
    }
    if (priority != null) {
      condition += '&priority=' + priority;
    }
    if (status != null && status !== '') {
      condition += '&status=' + status;
    }
    if (callerId != null && callerId !== '') {
      condition += '&callerId=' + callerId;
    }
    if (repairerId != null && repairerId !== '') {
      condition += '&repairerId=' + repairerId;
    }
    if (epNo != null && epNo !== '') {
      condition += '&epNo=' + epNo;
    }
    if (isProcessing != null) {
      condition += '&isProcessing=' + isProcessing;
    }
    if (search != null) {
      condition += '&search=' + search;
    }
    if (timeSortOrder != null) {
      condition += '&order=' + timeSortOrder;
    }
    if (idSortOrder != null) {
      condition += '&idOrder=' + idSortOrder;
    }
    if (prioritySortOrder != null) {
      condition += '&priorityOrder=' + prioritySortOrder;
    }
    if (isDelay != null) {
      condition += '&isDelay=' + isDelay;
    }
    if (isAccidentShutdown != null) {
      condition += '&isAccidentShutdown=' + isAccidentShutdown;
    }
    if (isDuplicate != null) {
      condition += '&isDuplicate=' + isDuplicate;
    }
    const result: any = await this.httpClient.get('plan/api/business/job/queryJobs' + condition).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.list == null) {
      // 请求数据失败
      return null;
    }
    if (this.jobLevels == null) {
      await this.initParam();
    }
    const list = result.data.list;
    const data = [];
    for (const item of list) {
      item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
      item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
      item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
      data.push(item);
    }
    return {
      total: result.data.total,
      data
    };
  }
  async getJobsByCondition(object: any): Promise<any> {
    let params = new HttpParams();
    if ( object.pageNum !== undefined && object.pageNum !== null){
      params = params.set('pageNum', object.pageNum);
    }
    if ( object.pageSize !== undefined && object.pageSize !== null){
      params = params.set('pageSize', object.pageSize);
    }
    if ( object.assetLevel !== undefined && object.assetLevel !== null){
      params = params.set('assetLevel', object.assetLevel);
    }
    if ( object.isEquipment !== undefined && object.isEquipment !== null){
      params = params.set('isEquipment', object.isEquipment);
    }
    if ( object.source !== undefined && object.source !== null){
      params = params.set('source', object.source);
    }
    if ( object.beginDate !== undefined && object.beginDate !== null){
      params = params.set('startTime', this.datePipe.transform(object.beginDate, 'yyyy-MM-dd 00:00:00'));
    }
    if ( object.endDate !== undefined && object.endDate !== null){
      params = params.set('endTime', this.datePipe.transform(object.endDate, 'yyyy-MM-dd 00:00:00'));
    }
    if ( object.typeId !== undefined && object.typeId !== null){
      params = params.set('businessTypeId', object.typeId);
    }
    if ( object.priority !== undefined && object.priority !== null){
      params = params.set('priority', object.priority);
    }

    if ( object.source !== undefined && object.source !== null){
      params = params.set('source', object.source);
    }
    if ( object.status !== undefined && object.status !== null){
      params = params.set('status', object.status);
    }
    if ( object.callerId !== undefined && object.callerId !== null){
      params = params.set('callerId', object.callerId);
    }
    if ( object.repairerId !== undefined && object.repairerId !== null){
      params = params.set('repairerId', object.repairerId);
    }
    if ( object.epNo !== undefined && object.epNo !== null){
      params = params.set('epNo', object.epNo);
    }
    if ( object.isProcessing !== undefined && object.isProcessing !== null){
      params = params.set('isProcessing', object.isProcessing);
    }
    if ( object.search !== undefined && object.search !== null){
      params = params.set('search', object.search);
    }
    if ( object.timeSortOrder !== undefined && object.timeSortOrder !== null){
      params = params.set('timeSortOrder', object.timeSortOrder);
    }
    if ( object.idSortOrder !== undefined && object.idSortOrder !== null){
      params = params.set('idSortOrder', object.idSortOrder);
    }
    if ( object.prioritySortOrder !== undefined && object.prioritySortOrder !== null){
      params = params.set('prioritySortOrder', object.prioritySortOrder);
    }
    if ( object.isDelay !== undefined && object.isDelay !== null){
      params = params.set('isDelay', object.isDelay);
    }
    if ( object.isAccidentShutdown !== undefined && object.isAccidentShutdown !== null){
      params = params.set('isAccidentShutdown', object.isAccidentShutdown);
    }
    if ( object.isDuplicate !== undefined && object.isDuplicate !== null){
      params = params.set('isDuplicate', object.isDuplicate);
    }
    if ( object.epNoForCheck !== undefined && object.epNoForCheck !== null){
      params = params.set('epNoForCheck', object.epNoForCheck);
    }
    if ( object.callerIdForCheck !== undefined && object.callerIdForCheck !== null){
      params = params.set('callerIdForCheck', object.callerIdForCheck);
    }
    let result: any = null;
    if (object.isPage !== undefined && object.isPage !== null &&  !object.isPage){
      result = await this.httpClient.get('plan/api/business/job/jobsNoPaging' , {params}).toPromise();
      if (result == null || result.code !== 200 || result.data == null) {
        // 请求数据失败
        return null;
      }
      if (this.jobLevels == null) {
        await this.initParam();
      }
      const list = result.data;
      const data = [];
      for (const item of list) {
        item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
        item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
        item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
        data.push(item);
      }
      return {
        total: result.data.length,
        data
      };
    }else{
      result = await this.httpClient.get('plan/api/business/job/queryJobs' , {params}).toPromise();
      if (result == null || result.code !== 200 || result.data == null || result.data.list == null) {
        // 请求数据失败
        return null;
      }
      if (this.jobLevels == null) {
        await this.initParam();
      }
      const list = result.data.list;
      const data = [];
      for (const item of list) {
        item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
        item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
        item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
        data.push(item);
      }
      return {
        total: result.data.total,
        data
      };
    }
  }
  async getJobsNoLogin(
    pageNum: number, pageSize: number, beginDate?: Date, endDate?: Date,
    typeId?: any, priority?: string, status?: string, callerId?: string,
    repairerId?: string, isProcessing?: boolean, search?: string, epNo?: string,
    timeSortOrder?: number,
    idSortOrder?: number, prioritySortOrder?: number, isDelay?: number, jnos?: string, contentLike?: string
  ): Promise<any> {
    let condition = '?pageNum=' + pageNum + '&pageSize=' + pageSize;
    if (beginDate != null) {
      condition += '&startTime=' + this.datePipe.transform(beginDate, 'yyyy-MM-dd 00:00:00');
    }
    if (endDate != null) {
      condition += '&endTime=' + this.datePipe.transform(endDate, 'yyyy-MM-dd 23:59:59');
    }
    if (typeId != null) {
      condition += '&businessTypeId=' + typeId.toString();
    }
    if (priority != null) {
      condition += '&priority=' + priority;
    }
    if (status != null && status !== '') {
      condition += '&status=' + status;
    }
    if (callerId != null && callerId !== '') {
      condition += '&callerId=' + callerId;
    }
    if (repairerId != null && repairerId !== '') {
      condition += '&repairerId=' + repairerId;
    }
    if (epNo != null && epNo !== '') {
      condition += '&epNo=' + epNo;
    }
    if (isProcessing != null) {
      condition += '&isProcessing=' + isProcessing;
    }
    if (search != null) {
      condition += '&search=' + search;
    }
    if (timeSortOrder != null) {
      condition += '&order=' + timeSortOrder;
    }
    if (idSortOrder != null) {
      condition += '&idOrder=' + idSortOrder;
    }
    if (prioritySortOrder != null) {
      condition += '&priorityOrder=' + prioritySortOrder;
    }
    if (jnos != null) {
      condition += '&jnos=' + jnos;
    }
    if (contentLike != null) {
      condition += '&contentLike=' + contentLike;
    }
    const result: any = await this.httpClient.get('plan/api/business/job/queryJobsNoLogin' + condition).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.list == null) {
      // 请求数据失败
      return null;
    }
    if (this.jobLevels == null) {
      await this.initParam();
    }
    const list = result.data.list;
    const data = [];
    for (const item of list) {
      item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
      item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
      item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
      data.push(item);
    }
    return {
      total: result.data.total,
      data
    };
  }

   // 获取条件获取全部符合条件的记录导出
  // 表单控件的值作为过滤条件，其他接口参数直接赋默认值
  async getJobsExecl(obj: any) {
    // 工单数组
    let orderArray: any[] = [];
    const  result = await this.getJobsByCondition(obj);
    orderArray = result.data;
    // 第一步：抽取数据构建对象数组，转化为sheet
    const myOrders: any[] = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < orderArray.length; i++) {
      const order = {
        编号: orderArray[i].jno,
        业务编号: orderArray[i].jtNo,
        主业务: orderArray[i].jtParentName,
        子业务: orderArray[i].jtName,
        计划编号: orderArray[i].pno,
        计划类型: orderArray[i].taskPlanType === '1' ? '巡检' : '普通',
        报修人: orderArray[i].callerName,
        报修人编号: orderArray[i].callerId === null ? '' : orderArray[i].callerId,
        报修人手机号: orderArray[i].callerPhone,
        报修时间: this.isEmpty(orderArray[i].createTime) ? '' : this.datePipe.transform(orderArray[i].createTime, 'yyyy-MM-dd HH:mm:ss'),
        维修员编号: orderArray[i].repairerNo === null ? '' : orderArray[i].repairerNo,
        维修员: orderArray[i].repairerName === null ? '' : orderArray[i].repairerName,
        位置: orderArray[i].location,
        级别编号: orderArray[i].jlNo,
        级别: orderArray[i].jlName,
        是否关联设备: (orderArray[i].epNo === null || orderArray[i].epNo === '' ) ? '否' : '是',
        设备编号: orderArray[i].epNo,
        预估工时: orderArray[i].hourEstimation,
        状态: this.getStatusName(orderArray[i].status),
        完成时间: this.isEmpty(orderArray[i].completedTime) ? '' : this.datePipe.transform(orderArray[i].completedTime, 'yyyy-MM-dd HH:mm:ss'),
        是否删除: this.getDelName(orderArray[i].delFlag),
        描述: orderArray[i].mark,
        预估完成时间: this.isEmpty(orderArray[i].estimatedCompletedTime) ? '' : this.datePipe.transform(orderArray[i].estimatedCompletedTime, 'yyyy-MM-dd HH:mm:ss'),
        是否第三方: orderArray[i].isThirdServices === '1' ? '是' : '否',
        完成报告: orderArray[i].completedRecord,
        调度员编号: orderArray[i].dispatcherNo,
        调度员: orderArray[i].dispatcherName,
        实际工时: orderArray[i].hourCompleted,
      };
      myOrders.push(order);
    }
    // 返回对象数组
    return myOrders;
  }
  // // 获取条件获取全部符合条件的记录导出
  // // 表单控件的值作为过滤条件，其他接口参数直接赋默认值
  // async getJobsExecl(
  //   beginDate?: Date, endDate?: Date,
  //   typeId?: any, isDelay?: number, levelId?: number
  // ) {
  //   let condition = '';
  //   if (beginDate != null) {
  //     condition += '&startTime=' + this.datePipe.transform(beginDate, 'yyyy-MM-dd 00:00:00');
  //   }
  //   if (levelId != null) {
  //     condition += '&priority=' + levelId;
  //   }
  //   if (endDate != null) {
  //     condition += '&endTime=' + this.datePipe.transform(endDate, 'yyyy-MM-dd 23:59:59');
  //   }
  //   if (typeId != null) {
  //     condition += '&businessTypeId=' + typeId.toString();
  //   }
  //   if (isDelay != null) {
  //     condition += '&isDelay=' + isDelay;
  //   }
  //   let result: any;
  //   try {
  //     const url = 'plan/api/business/job/jobsNoPaging' +
  //       '?deptId=0&idOrder=2&repairerId=-1&order=0&priorityOrder=2'
  //       + condition;
  //     result = await this.httpClient.get(url).toPromise();
  //   } catch (e) {
  //     console.log(`getJobsExecl错误：${e}`);
  //   }
  //   // 工单数组
  //   const orderArray: any[] = result.data;
  //   // 第一步：抽取数据构建对象数组，转化为sheet
  //   const myOrders: any[] = [];
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let i = 0; i < orderArray.length; i++) {
  //     const order = {
  //       编号: orderArray[i].jno,
  //       业务编号: orderArray[i].jtNo,
  //       主业务: orderArray[i].jtParentName,
  //       子业务: orderArray[i].jtName,
  //       计划编号: orderArray[i].pno,
  //       计划类型: orderArray[i].taskPlanType === '1' ? '巡检' : '普通',
  //       报修人: orderArray[i].callerName,
  //       报修人编号: orderArray[i].callerId === null ? '' : orderArray[i].callerId,
  //       报修人手机号: orderArray[i].callerPhone,
  //       报修时间: this.isEmpty(orderArray[i].createTime) ? '' : this.datePipe.transform(orderArray[i].createTime, 'yyyy-MM-dd HH:mm:ss'),
  //       维修员编号: orderArray[i].repairerNo === null ? '' : orderArray[i].repairerNo,
  //       维修员: orderArray[i].repairerName === null ? '' : orderArray[i].repairerName,
  //       位置: orderArray[i].location,
  //       级别编号: orderArray[i].jlNo,
  //       级别: orderArray[i].jlName,
  //       是否关联设备: (orderArray[i].epNo === null || orderArray[i].epNo === '' ) ? '否' : '是',
  //       设备编号: orderArray[i].epNo,
  //       预估工时: orderArray[i].hourEstimation,
  //       状态: this.getStatusName(orderArray[i].status),
  // tslint:disable-next-line:max-line-length
  //       完成时间: this.isEmpty(orderArray[i].completedTime) ? '' : this.datePipe.transform(orderArray[i].completedTime, 'yyyy-MM-dd HH:mm:ss'),
  //       是否删除: this.getDelName(orderArray[i].delFlag),
  //       描述: orderArray[i].mark,
  // tslint:disable-next-line:max-line-length
  //       预估完成时间: this.isEmpty(orderArray[i].estimatedCompletedTime) ? '' : this.datePipe.transform(orderArray[i].estimatedCompletedTime, 'yyyy-MM-dd HH:mm:ss'),
  //       是否第三方: orderArray[i].isThirdServices === '1' ? '是' : '否',
  //       完成报告: orderArray[i].completedRecord,
  //       调度员编号: orderArray[i].dispatcherNo,
  //       调度员: orderArray[i].dispatcherName,
  //       实际工时: orderArray[i].hourCompleted,
  //       // 关联设备编号: orderArray[i].epNo,
  //       // 关联设备名称: orderArray[i].epName,
  //       // 报修人电话: orderArray[i].callerPhone,
  //       // 详细描述: orderArray[i].mark,
  //       // 维修记录: orderArray[i].completedRecord,
  //       // 审核描述: orderArray[i].verifyDesc,
  //       // 管理员文字评价: orderArray[i].textEvaluationAdmin,
  //       // 管理员及时性星级评价: orderArray[i].starEvaluationAdmin,
  //       // 管理员态度星级评价: orderArray[i].starAttitudeEvaluationAdmin,
  //       // 管理员维修质量星级评价: orderArray[i].starQualityEvaluationAdmin,
  //       // 报修人文字评价: orderArray[i].textEvaluationCaller,
  //       // 报修人及时性星级评价: orderArray[i].starEvaluationCaller,
  //       // 报修人态度星级评价: orderArray[i].starAttitudeEvaluationCaller,
  //       // 报修人维修质量星级评价: orderArray[i].starQualityEvaluationCaller,

  //     };
  //     // 将对象的状态（数值）替换为描述性语言
  //     // switch (orderArray[i].status) {
  //     //   case '1':
  //     //     order[`状态`] = '未处理';
  //     //     break;
  //     //   case '2':
  //     //     order[`状态`] = '已派工';
  //     //     break;
  //     //   case '3':
  //     //     order[`状态`] = '处理中';
  //     //     break;
  //     //   case '4':
  //     //     order[`状态`] = '待审核';
  //     //     break;
  //     //   default:
  //     //     order[`状态`] = '已完成';
  //     // }
  //     myOrders.push(order);
  //   }
  //   // 返回对象数组
  //   return myOrders;
  // }
  getStatusName(status){
    switch (status) {
      case '1':
        return '未处理';
      case '2':
        return  '已派工';
      case '3':
        return  '处理中';
      case '4':
        return  '待审核';
      default:
        return '已完成';
    }
  }
  getDelName(delFlag){
    if (delFlag == null || delFlag === '0'){
      return '未删除';
    }else{
      return  '已删除';
    }
  }


  async getJobsByFilterCondition(
    startStatus?: number,
    endStatus?: number,
    days?: number,
    dispatcherNo?: number,
    repairerNo?: number
  ): Promise<any> {
    let condition = '?';
    if (startStatus != null) {
      condition += 'startStatus=' + startStatus + '&';
    }
    if (endStatus != null) {
      condition += '&endStatus=' + endStatus + '&';
    }
    if (days != null) {
      condition += '&days=' + days + '&';
    }
    if (dispatcherNo != null) {
      condition += '&dispatcherNo=' + dispatcherNo + '&';
    }
    if (repairerNo != null) {
      condition += '&repairerNo=' + repairerNo + '&';
    }
    condition = condition.substring(0, condition.length - 1);
    const result: any = await this.httpClient.get('plan/api/business/job/queryJobsByConditions' + condition).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      if (this.jobLevels == null) {
        await this.initParam();
      }
      const list = result.data;
      const data = [];
      for (const item of list) {
        item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
        item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
        item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
        if (item.estimatedCompletedTime != null) {
          const date = new Date();
          const estimatedCompletedTime = new Date(item.estimatedCompletedTime);
          if (date.getTime() > estimatedCompletedTime.getTime()) {
            item.overtime = '已超时';
          } else {
            item.overtime = '未超时';
          }
        } else {
          item.overtime = '未知';
        }

        data.push(item);
      }
      return result.data;
    }
  }
  async getJobsByCallerId(callerId: number) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryByCallerId/' + callerId).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }
  async getCountByPno(code: number) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryCountByPno/' + code).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }
  async getUnDispatchJobsByUseId(userId: number) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryUnDispatchJobsByUseId/' + userId).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }
  async getDoneJobsByRepairNo(repairNo: number) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryDoneJobsByRepairNo/' + repairNo).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }
  async getDoneJobsByRepairNoAndDate(repairerNo: number, date: Date) {
    const params = new HttpParams()
      .set('repairerNo', repairerNo.toString())
      .set('date', date.toDateString());
    const result: any = await this.httpClient.get('plan/api/business/job/queryDoneJobsByRepairNoAndDate', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }
  async getDoneJobsByDispatcherNo(dispatcherNo: number) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryDoneJobsByDispatcherNo/' + dispatcherNo).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      // 请求数据失败
      return null;
    } else {
      return result.data;
    }
  }

  async getJobByAlarmId(alarmId: string) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryJobByAlarmId/' + alarmId).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return 0;
    }
    return result.data;
  }

  async getJob(jobId: string) {
    const result: any = await this.httpClient.get('plan/api/business/job/queryByJno/' + jobId).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    if (this.jobLevels == null) {
      await this.initParam();
    }
    const item = result.data;
    item.levelName = this.jobLevels ? this.jobLevels.get(item.jlNo) : null;
    item.typeName = this.jobTypes ? this.jobTypes.get(item.jtNo) : null;
    item.statusName = this.jobStatus ? this.jobStatus.get(item.status) : null;
    if (item.isEquipment === '1') {
      item.deviceName = '未实现固定资产名称获取';
    }
    // 为确保评星显示正常，将string转为number
    if (typeof item.starEvaluationCaller === 'string') {
      item.starEvaluationCaller = Number.parseFloat(item.starEvaluationCaller);
    }
    // 为确保评星显示正常，将string转为number
    if (typeof item.starEvaluationAdmin === 'string') {
      item.starEvaluationAdmin = Number.parseFloat(item.starEvaluationAdmin);
    }
    // 附件
    const attachments = await this.getJobAttachment(item.jno);
    if (attachments != null && attachments.length > 0) {
      item.attachments = [];
      for (const attachment of attachments) {
        item.attachments.push({
          id: attachment.id,
          url: 'attachmentServer' + attachment.url,
          status: 'done',
        });
      }
    } else {
      item.attachments = null;
    }
    // 维修前附件
    const beforeAttachments = await this.getJobBeforeAttachment(item.jno);
    if (beforeAttachments != null && beforeAttachments.length > 0) {
      item.beforeRecordAttachments = [];
      for (const attachment of beforeAttachments) {
        item.beforeRecordAttachments.push({
          id: attachment.id,
          url: 'attachmentServer' + attachment.url,
          status: 'done',
        });
      }
    } else {
      item.beforeRecordAttachments = null;
    }
    // 维修后附件
    const completedAttachments = await this.getJobCompletedAttachment(item.jno);
    if (completedAttachments != null && completedAttachments.length > 0) {
      item.completedRecordAttachments = [];
      for (const attachment of completedAttachments) {
        item.completedRecordAttachments.push({
          id: attachment.id,
          url: 'attachmentServer' + attachment.url,
          status: 'done',
        });
      }
    } else {
      item.completedRecordAttachments = null;
    }
    return result.data;
  }

  async getJobAttachment(jobId: string) {
    const params = new HttpParams()
      .set('jobId', jobId);
    const result: any = await this.httpClient.get('plan/api/business/attachment/queryJobAttachment',
      { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async getJobBeforeAttachment(jobId: string) {
    const params = new HttpParams()
      .set('jobId', jobId);
    const result: any = await this.httpClient.get('plan/api/business/attachment/queryJobBeforeAttachment',
      { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async getJobCompletedAttachment(jobId: string) {
    const params = new HttpParams()
      .set('jobId', jobId);
    const result: any = await this.httpClient.get('plan/api/business/attachment/queryJobCompletedAttachment',
      { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  updateJob(job: any) {
    return this.httpClient.put('plan/api/business/job/update', job).pipe(
      map((res: any) => res)
    );
  }
  setDupJob(jno: any, relateJno: any) {
    const job = {
      jno,
      relateJno
    };
    return this.httpClient.put('plan/api/business/job/dupJob', job);
  }
  setUnDupJob(jno: any) {
    const job = {
      jno
    };
    return this.httpClient.put('plan/api/business/job/unDupJob', job);
  }

  updateJobSelective(job: any) {
    return this.httpClient.put('plan/api/business/job/updateSelective', job).pipe(
      map((res: any) => res)
    );
  }

  async getJobTraces(jobId: number): Promise<any[]> {
    const result: any = await this.httpClient.get('plan/api/business/jobTrace/queryByJno/' + jobId).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  async getJobByStatus(status: number): Promise<any[]> {
    const result: any = await this.httpClient.get('plan/api/business/job/queryByStatus/' + status).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询可以处理当前工单的所有人员（维修员）
  async getUsersBySkillId(date: any, skillId) {
    const params = new HttpParams()
      .set('date', date)
      .set('skillId', skillId);
    const result: any = await this.httpClient.get('plan/api/business/job/queryStaffs/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询当前工单，已被派遣的值班人员（维修员）
  async getUsersByDateAndUserId(date: any, userId) {
    const params = new HttpParams()
      .set('date', date)
      .set('userId', userId);
    const result: any = await this.httpClient.get('plan/api/business/job/queryStaff/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询维修员
  async getUserByUserId(userId) {
    const params = new HttpParams()
      .set('userId', userId);
    const result: any = await this.httpClient.get('plan/api/business/job/queryRepairerNameByRepairerNo/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询可以处理当前工单的值班人员（维修员）
  async getDutysByDateAndJobType(date: any, jobType) {
    const params = new HttpParams()
      .set('date', date)
      .set('jobType', jobType);
    const result: any = await this.httpClient.get('plan/api/business/job/queryDutys/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 根据完成情况和大类型查询当日工单
  async getJobsByTypeAndStatus(skill: any, status: any) {
    const params = new HttpParams()
      .set('skill', skill)
      .set('status', status);
    const result: any = await this.httpClient.get('plan/api/business/job/queryJobByTypeAndStatus/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 根据优先级查询当日工单
  async getTodayJobByPriority(flag: any, priority: any) {
    const params = new HttpParams()
      .set('flag', flag)
      .set('priority', priority);
    const result: any = await this.httpClient.get('plan/api/business/job/queryTodayJobByPriority/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询当日工单
  async getTodayJob(flag: any) {
    const params = new HttpParams()
      .set('flag', flag);
    const result: any = await this.httpClient.get('plan/api/business/job/queryTodayJob/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 根据建筑查询已完成工单
  async getCompletedJobByArchitecture(architecture: any) {
    const params = new HttpParams()
      .set('architecture', architecture);
    const result: any = await this.httpClient.get('plan/api/business/job/queryCompletedJobByArchitecture/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 根据优先级查询某类型全部未完成工单
  async getAllUncompletedJobByPriority(skill: any, level: any) {
    const params = new HttpParams()
      .set('skill', skill)
      .set('level', level);
    const result: any = await this.httpClient.get('plan/api/business/job/queryAllUncompletedJobByPriority/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询当前工单，已被派遣的值班人员（维修员）
  async getDutyByDateAndUserId(date: any, userId) {
    const params = new HttpParams()
      .set('date', date)
      .set('userId', userId);
    const result: any = await this.httpClient.get('plan/api/business/job/queryDuty/', { params }).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  async addJobNote(note: any) {
    return await this.httpClient.post('plan/api/business/job/addNote', note).toPromise();
  }

  async getSpareListByJob(jobId: string) {
    // const params = new HttpParams()
    //   .set('jNo', jobId);
    const result: any = await this.httpClient.get('plan/api/receiveList/job?jNo=' + jobId).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  async addAttachment(attachment: any, isInRecord?: number) {
    isInRecord = isInRecord != null ? isInRecord : 1;
    // tslint:disable-next-line:max-line-length
    return await this.httpClient.post('plan/api/business/attachment/add', { attachments: attachment, isInRecord }).toPromise();
  }
  async deleteAttachment(id: any) {
    return await this.httpClient.delete(`plan/api/business/attachment/delete/${id}`).toPromise();
  }
  getJobsByTypeForDashboard() {
    return this.httpClient.get('plan/api/business/job/queryJobCountWithStatus');
  }

  // 查询月度工单费用pie(费用类型)
  async getJobFeeByCostType(
    flag: string,
    start: Date,
    end?: Date
  ) {
    let url = `plan/api/business/jobStatistics/jobFee?flag=${flag}`;
    switch (flag) {
      case 'month':

        url = url + `&start=${this.dateFormat(start)}`;
        break;
      case 'year':
        url = url + `&start=${this.dateFormat(start)}`;
        break;
      case 'quarter':
        const value1 = `&start=${this.dateFormat(start)}`;
        const value2 = `&end=${this.dateFormat(end)}`;
        url = url + value1 + value2;
        break;
      default:
    }
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 查询月度工单费用pie(费用类型)
  async getJobFeeByCostTypeBar(date: Date) {
    let url = 'plan/api/business/jobStatistics/jobFeeBar';
    url = url + `/${date.getFullYear()}/${date.getMonth() + 1}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 查询月度工单费用(供应商名字)
  async getJobFeeByProviderBar(date: Date) {
    let url = 'plan/api/business/jobStatistics/jobFeeProviderBar';
    url = url + `/${date.getFullYear()}/${date.getMonth() + 1}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 查询月度工单费用(供应商名字)
  async getJobFeeByProvider(
    start: Date,
    end: Date
  ) {
    let url = 'plan/api/business/jobStatistics/jobFeeProvider';
    const value1 = `?start=${this.dateFormat(start)}`;
    const value2 = `&end=${this.dateFormat(end)}`;
    url = url + value1 + value2;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 查询月度工单费用(业务类型)
  async getJobFeeBySkill(
    flag: string,
    start: Date,
    end?: Date
  ) {
    let url = `plan/api/business/jobStatistics/jobFeeBySkill?flag=${flag}`;
    if (start !== undefined && start !== null) {
      url = url + `&start=${this.dateFormat(start)}`;
    }
    if (end !== undefined && end !== null) {
      url = url + `&end=${this.dateFormat(end)}`;
    }
    const result: any = await this.httpClient.get(url).toPromise();
    if (result === undefined || result === null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }


  // Date数据转化为yyyy-MM-dd格式的字符串
  dateFormat(date: Date) {
    const Date: string[] = [];
    if (date === undefined && date === null) {
      return null;
    }
    const array = date.toLocaleDateString().split(`/`);
    array.forEach((item) => {
      if (item.length < 2) {
        Date.push(`0${item}`);
      } else {
        Date.push(item);
      }
    });
    const dateStr = Date.join(`-`);
    return dateStr;
  }

  // 查询月度工单费用
  async getJobMonthlyFee(date: Date) {
    let url = 'plan/api/business/jobStatistics/jobMonthlyFee';
    // ${date.getMonth()+1}
    url = url + `/${date.getFullYear()}/${date.getMonth() + 1}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 按照业务统计巡检任务及生成工单
   * param: string 月份
   */
  async getJobOrderBySkill(
    year?: string,
    month?: string
  ) {
    let url = 'plan/api/operation/jobOrderBySkill';
    url = url + `/${year}/${month}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 按照业务统计巡检任务及生成工单
   * param: string 年份
   */
  async getJobOrderByYear(year: string) {
    let url = 'plan/api/operation/jobOrderByYear';
    url = url + `/${year}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 统计工单和巡检任务的年份
   */
  async getYearsJobAndTask() {
    const url = 'plan/api/operation/yearsJobAndTask';
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 按照业务统计巡检任务及生成工单（季度）
   * param: string 季度
   */
  async getJobOrderByQuarter(
    year?: string,
    quarter?: string
  ) {
    let url = 'plan/api/operation/jobOrderByQuarter';
    // 0的含义是月份，1的含义是季度
    url = url + `/${year}/${quarter}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 查询工单大类
   */
  async getJobBigTypes() {
    const url = 'plan/api/business/jobType/bigTypes';
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 根据工单大类ID查询所有子节点
   */
  async getTypesByParentID(jtId) {
    const url = `plan/api/business/jobType/queryList/${jtId}`;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  /**
   * 查询工单状态
   */
  async getJobStatus() {
    const ret: any = await this.httpClient.get('plan/api/business/jobStatus/queryAll').toPromise();
    return ret;
  }
  /**
   * 查询当日工单
   */
  async getTodayJobData() {
    const ret: any = await this.httpClient.get('plan/api/operation/aecTodayJob').toPromise();
    return ret;
  }

  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 根据id集合查询维修工单集合
   * @param array 维修工单id数组
   * @returns 维修工单集合
   */
  async getRepairJobsByIds(ids: string){
    if (!this.isEmpty(ids)){
      const url = 'plan/api/business/job/repairJobs';
      const params = new HttpParams().set('ids', ids);
      const result: any = await this.httpClient.get(url, {params}).toPromise();
      if (result == null || result.code !== 200 || result.data == null) {
        return null;
      }
      return result.data;
    }
  }
}
